const state = {
  examManageName: localStorage.getItem('examManageName') || ''
}

const mutations = {
  // 设置考试名称
  SET_EXAM_MANAGE_NAME(state, name) {
    state.examManageName = name
    localStorage.setItem('examManageName', name)
  },
  // 清除考试相关信息
  CLEAR_EXAM_MANAGE_INFO(state) {
    state.examManageName = ''
    localStorage.removeItem('examManageName')
  }
}

const actions = {
  // 设置考试信息（只处理名称）
  setExamManageInfo({ commit }, { name }) {
    commit('SET_EXAM_MANAGE_NAME', name)
  },
  // 清除考试信息
  clearExamManageInfo({ commit }) {
    commit('CLEAR_EXAM_MANAGE_INFO')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}